import React, { useRef, useState } from "react";
import Form from "react-validation/build/form";
import Input from "react-validation/build/input";
import CheckButton from "react-validation/build/button";
import { isEmail } from "validator";
import { Link } from "react-router-dom";
import RegisterService from "../services/register.service";

const required = (value) => {
  if (!value) {
    return <div className="invalid-feedback d-block">This field is required.</div>;
  }
};

const validEmail = (value) => {
  if (!isEmail(value)) {
    return <div className="invalid-feedback d-block">This is not a valid email.</div>;
  }
};

const vusername = (value) => {
  if (value.length < 3 || value.length > 20) {
    return (
      <div className="invalid-feedback d-block">
        The username must be between 3 and 20 characters.
      </div>
    );
  }
};

const vpassword = (value) => {
  if (value.length < 6 || value.length > 40) {
    return (
      <div className="invalid-feedback d-block">
        The password must be between 6 and 40 characters.
      </div>
    );
  }
};

const Register = () => {
  const form = useRef();
  const checkBtn = useRef();
  const [username, setUsername] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [successful, setSuccessful] = useState(false);
  const [message, setMessage] = useState("");

  const handleRegister = (event) => {
    event.preventDefault();
    setMessage("");
    setSuccessful(false);

    form.current.validateAll();

    if (checkBtn.current.context._errors.length === 0) {
      RegisterService.register(username, email, password).then(
        (response) => {
          setMessage(response.data.message);
          setSuccessful(true);
        },
        (error) => {
          const responseMessage =
            (error.response && error.response.data && error.response.data.message) ||
            error.message ||
            error.toString();

          setMessage(responseMessage);
          setSuccessful(false);
        }
      );
    }
  };

  return (
    <div className="auth-form-card">
      <div className="auth-form-card__brand">
        <span className="portal-pill portal-pill--outline">Administrator onboarding</span>
        <h2>Create an admin account</h2>
        <p>
          Set up secure access for a portal administrator who will manage clients, users,
          and enterprise reporting.
        </p>
      </div>

      <Form onSubmit={handleRegister} ref={form}>
        {!successful ? (
          <>
            <div className="form-group mb-3">
              <label htmlFor="username">Username</label>
              <Input
                type="text"
                className="form-control"
                name="username"
                value={username}
                onChange={(event) => setUsername(event.target.value)}
                validations={[required, vusername]}
              />
            </div>

            <div className="form-group mb-3">
              <label htmlFor="email">Email</label>
              <Input
                type="text"
                className="form-control"
                name="email"
                value={email}
                onChange={(event) => setEmail(event.target.value)}
                validations={[required, validEmail]}
              />
            </div>

            <div className="form-group mb-3">
              <label htmlFor="password">Password</label>
              <Input
                type="password"
                className="form-control"
                name="password"
                value={password}
                onChange={(event) => setPassword(event.target.value)}
                validations={[required, vpassword]}
              />
            </div>

            <div className="d-grid gap-2">
              <button className="btn btn-primary auth-submit-button">Create account</button>
            </div>
          </>
        ) : null}

        {message ? (
          <div className="form-group mt-3">
            <div
              className={successful ? "alert alert-success mb-0" : "alert alert-danger mb-0"}
              role="alert"
            >
              {message}
            </div>
          </div>
        ) : null}

        <div className="auth-form-card__footer">
          <span>Already have access?</span>
          <Link to="/login">Return to sign in</Link>
        </div>

        <CheckButton style={{ display: "none" }} ref={checkBtn} />
      </Form>
    </div>
  );
};

export default Register;
